'use strict';

;( () => {

	const tinySlider = document.querySelectorAll( '[data-tiny-slider]' );
	if ( 0 === tinySlider.length ) return;

	tinySlider.forEach( slider => {

		if ( 0 === slider.children.length ) return;

		const options = {
			container: slider,
			mouseDrag: true,
			slideBy  : 1,
		};

		switch ( slider.dataset.tinySlider ) {

		case 'front-page':
			options.controls    = false;
			options.items       = 1;
			options.navPosition = 'bottom';
			options.responsive  = {
				768 : { items: 2 },
				1024: { disable: true },
			};
			break;

		case 'quote-slider':
			options.autoplay             = true;
			options.autoplayButtonOutput = false;
			options.autoplayTimeout      = 12500;
			options.controls             = false;
			options.items                = 1;
			options.navPosition          = 'bottom';
			options.speed                = 1000;
			options.controlsPosition     = 'bottom',
			options.responsive           = {
				1024: {
					nav     : false,
					controls: true,
				}
			};
			break;

		case 'partners':
			options.autoplay             = true;
			options.autoplayButtonOutput = false;
			options.autoplayTimeout      = 6500;
			options.controls             = false;
			options.items                = 1;
			options.navPosition          = 'bottom';
			options.speed                = 450;
			options.responsive           = {
				768: {
					items : 2,
					gutter: 42,
				},
				1024: { disable: true }
			};
			break;
		}

		tns( options );
	});

})();
